module.exports = __webpack_public_path__ + "img/ssyx_09.92c1440e.jpg";